// The one table of calendar preset offsets, in days from today. `buildQueries.ts`,
// `PDF/snapshotDateRange.ts` and `Utils/slicerVariables.mjs` read it, so a slicer title
// and the query it governs agree on the window. Pure, so the node runner can load it.

/** @type {Record<string, number>} */
export const PRESET_OFFSETS = {
  today: 0,
  last1week: -7,
  last2weeks: -14,
  last4weeks: -28,
  last3months: -90,
  lastSeason: -365,
};

/** The offset an unknown or missing preset falls back to (four weeks). */
export const DEFAULT_PRESET_OFFSET = -28;

/**
 * The presets that resolve to a session window instead of a calendar span. Mirrors
 * TRAINING_COUNT_RANGES in `AddWidgetModal/constants.ts`, which the node runner cannot
 * load because of its extension-less imports.
 * @type {Record<string, number>}
 */
export const TRAINING_COUNT_PRESETS = {
  last5trainings: 5,
  last10trainings: 10,
};

/**
 * Whether these date fields describe a session window. Mirrors `usesSessionWindow` in
 * `AddWidgetModal/constants.ts`: the custom range decides while it is open, and the
 * preset decides while it is closed.
 * @param {{ showAdvancedDate?: boolean, startDateType?: string, dateRange?: string, dateRangePreset?: string } | undefined} fields
 * @returns {boolean}
 */
export function isSessionWindow(fields) {
  if (fields?.showAdvancedDate) return fields.startDateType === "latest_n";
  const preset = fields?.dateRangePreset ?? fields?.dateRange ?? "";
  return Object.prototype.hasOwnProperty.call(TRAINING_COUNT_PRESETS, preset);
}
